import React from 'react'
import { 
  Badge, 
  BadgeArea, 
  BaseButton, 
  CardEventHeader, 
  DefaultEventCard,
 } from 'iebt-zing-storybook'
import { removeTagsHTML } from 'sharedKernel/handlers'
import { Track } from 'domain/track/trackContainer'
import { CardGrid } from './style'

export interface AdmTrackCardListProps {
  tracks: Track[]
  onEdit: (id: Track['id']) => void
  onDelete: (id: Track['id']) => void
  onCardClick: (track: Track) => void
}

const getTrackBadgeStatus = (status: Track['status']): 'pending' | 'launched' => {
  if (status === 'publicado' || status === 'Publish') {
    return 'launched'
  }
  return 'pending'
}

export const AdmTrackCardList = ({
  tracks,
  onEdit,
  onDelete,
  onCardClick
}: AdmTrackCardListProps): JSX.Element => {
  return (
    <CardGrid>
      {tracks?.map((track, index) => {
        const badgeStatus = getTrackBadgeStatus(track.status)

        const header = <CardEventHeader coverImage={track?.imageUrl ?? ''} />

        const lessonsCount = track?.numberOfLessons ?? track?.lessons

        const badgeItems: JSX.Element[] = [
          <Badge key={`status-${index}`} icon={['fas', 'signal']} status={badgeStatus} />
        ]
        if (lessonsCount) {
          badgeItems.push(<Badge key={`lessons-${index}`} icon={['fas', 'lightbulb']} text="Aulas" value={lessonsCount} />)
        }

        const badges = <BadgeArea>{badgeItems}</BadgeArea>

        const buttons = [
          <BaseButton
            key={`edit-${track.id}`}
            variant="risk"
            size="medium"
            onClick={() => onEdit(track.id)}
            btnContent="Editar"
          />,
          <BaseButton
            key={`delete-${track.id}`}
            variant="risk-secondary"
            size="medium"
            onClick={() => onDelete(track.id)}
            btnContent="Excluir"
          />
        ]

        return (
          <DefaultEventCard
            key={track.id}
            title={track.title}
            shortDescription={removeTagsHTML(track.description ?? '')}
            badges={badges}
            header={header}
            buttons={buttons}
            sendTo={() => onCardClick(track)}
          />
        )
      })}
    </CardGrid>
  )
}
